export default function getCurrentCity() {
  return window.Sti.currentCity;
}
